module.exports = __webpack_public_path__ + "img/jenifer.b435f62.jpg";